import React from "react";
import {FunnelChart} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCFunnelChart extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onItemClick", "onItemClick"],
        ["ShowToolbar", "showToolbar"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["Width", "width"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <FunnelChart {...chartProps} sx={this.props.sx} />;
    }
}

export default CCFunnelChart;
